// SEO por página e idioma: título y descripción desde el contenido del sitio
function recortar(s, max = 155) {
  if (!s) return s;
  return s.length > max ? s.slice(0, max - 1).replace(/\s+\S*$/, '') + '…' : s;
}

export function seoDeRuta(ruta, t) {
  const marca = 'La Carla Posada Boutique';
  const mapa = {
    '': [`${t.home.hero.titulo} · ${marca}`, t.home.presentacion.cuerpo],
    habitaciones: [`${t.habitaciones.hero.titulo} · ${marca}`, t.habitaciones.presentacion.cuerpo],
    gastronomia: [`${t.gastronomia.hero.titulo} · ${marca}`, t.gastronomia.presentacion.cuerpo],
    servicios: [`${t.servicios.hero.titulo} · ${marca}`, t.servicios.presentacion.cuerpo],
    eventos: [`${t.eventos.hero.titulo} · ${marca}`, t.eventos.presentacion.texto],
    'eventos/sociales': [`${t.eventoTipo.sociales.hero.titulo} · ${marca}`, t.eventoTipo.sociales.presentacion.p1],
    'eventos/empresariales': [`${t.eventoTipo.empresariales.hero.titulo} · ${marca}`, t.eventoTipo.empresariales.presentacion.p1],
    'espacios/living': [`${t.espacios.living.hero.titulo} · ${marca}`, t.espacios.living.texto[0]],
    'espacios/desayunador': [`${t.espacios.desayunador.hero.titulo} · ${marca}`, t.espacios.desayunador.texto[0]],
    'espacios/comedor': [`${t.espacios.comedor.hero.titulo} · ${marca}`, t.espacios.comedor.texto[0]],
    'espacios/galeria': [`${t.espacios.galeria.hero.titulo} · ${marca}`, t.espacios.galeria.texto[0]],
    'espacios/jardin': [`${t.espacios.jardin.hero.titulo} · ${marca}`, t.espacios.jardin.texto[0]],
    'que-hacer': [`${t.queHacer.hero.titulo} · ${marca}`, t.queHacer.presentacion.cuerpo],
    'que-hacer/caminos-del-agua': [`${t.actividades.caminos.hero.titulo} · ${marca}`, t.actividades.caminos.descripcion],
    'que-hacer/pinturas-rupestres': [`${t.actividades.pinturas.hero.titulo} · ${marca}`, t.actividades.pinturas.descripcion],
    'que-hacer/cabalgata-corralito': [`${t.actividades.cabalgata.hero.titulo} · ${marca}`, t.actividades.cabalgata.descripcion],
    fotos: [`${t.fotos.hero.titulo} · ${marca}`, t.fotos.presentacion.cuerpo],
    contacto: [`${t.contacto.hero.titulo} · ${marca}`, t.contacto.ubicacion.cuerpo],
    'quienes-somos': [`${t.quienesSomos.hero.titulo} · ${marca}`, t.quienesSomos.origen.cuerpo],
    terminos: [`${t.terminos.hero.titulo} · ${marca}`, t.terminos.cuerpo],
    cookies: [`${t.cookies.hero.titulo} · ${marca}`, t.cookies.cuerpo],
    sustentabilidad: [`${t.sustentabilidad.hero.titulo} · ${marca}`, t.sustentabilidad.cuerpo],
    comunidad: [`${t.comunidad.hero.titulo} · ${marca}`, t.comunidad.cuerpo],
    'preguntas-frecuentes': [`${t.faq.hero.titulo} · ${marca}`, t.faq.cuerpo],
    'informacion-util': [`${t.infoUtil.hero.titulo} · ${marca}`, t.infoUtil.presentacion.cuerpo],
  };
  if (mapa[ruta]) {
    const datos = mapa[ruta];
    return { titulo: datos[0], descripcion: recortar(datos[1]) };
  }
  if (ruta.startsWith('fotos/')) {
    const cat = ruta.slice(6);
    const textos = t.fotos.galerias[cat];
    const extras = {
      'caminos-del-agua': t.actividades.caminos.descripcion,
      'pinturas-rupestres': t.actividades.pinturas.descripcion,
      'cabalgata-corralito': t.actividades.cabalgata.descripcion,
      'eventos-sociales': t.eventoTipo.sociales.presentacion.p1,
      'eventos-empresariales': t.eventoTipo.empresariales.presentacion.p1,
      'produccion': t.servicios.produccion.apoyo,
    };
    if (textos) return { titulo: `${textos.titulo} · ${marca}`, descripcion: recortar(textos.texto || extras[cat] || '') };
  }
  const datos = mapa[''];
  return { titulo: datos[0], descripcion: recortar(datos[1]) };
}

export function aplicarSEO(ruta, t) {
  const { titulo, descripcion } = seoDeRuta(ruta, t);
  document.title = titulo;
  const fija = (attr, valor) => {
    let el = document.head.querySelector(`meta[${attr}]`);
    if (!el) {
      el = document.createElement('meta');
      const [k, v] = attr.replace('[', '').replace(']', '').split('=');
      el.setAttribute(k, v);
      document.head.appendChild(el);
    }
    el.setAttribute('content', valor);
  };
  fija('name="description"', descripcion || '');
  fija('property="og:title"', titulo);
  fija('property="og:description"', descripcion || '');
}